import { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../auth/AuthContext';

export default function AdminDashboardUser() {
  const { csrfToken } = useAuth();
  const [users, setUsers] = useState([]);
  const [emailToPromote, setEmailToPromote] = useState('');
  const [error, setError] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const u = await axios.get('/admin/users');
        setUsers(u.data.users);
      } catch {
        setError('Error fetching users');
      }
    })();
  }, []);

  async function promoteUser(e) {
    e.preventDefault();
    setError(null);
    try {
      const { data } = await axios.post('/admin/promote', { email: emailToPromote }, {
        headers: { 'X-CSRF-Token': csrfToken }
      });
      setUsers(prev => prev.map(u => u.email === data.user.email ? { ...u, role: data.user.role } : u));
      setEmailToPromote('');
    } catch (err) {
      setError(err.response?.data?.error || 'Role promotion failed');
    }
  }

  return (
    <div className="container py-5">
      <h1 className="h4 mb-4">Manage Users</h1>
      {error && <div className="alert alert-danger">{error}</div>}

      <form className="row g-3 mb-4" onSubmit={promoteUser}>
        <div className="col">
          <input className="form-control" type="email" placeholder="User email to promote to admin"
            value={emailToPromote} onChange={e => setEmailToPromote(e.target.value)} required />
        </div>
        <div className="col-auto">
          <button className="btn btn-primary" type="submit">Promote to Admin</button>
        </div>
      </form>

      <div className="table-responsive">
        <table className="table table-sm align-middle">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Role</th>
              <th>Registration Date</th>
            </tr>
          </thead>
          <tbody>
            {users.map(u => (
              <tr key={u._id}>
                <td>{u.name}</td>
                <td>{u.email}</td>
                <td><span className={`badge ${u.role === 'admin' ? 'bg-danger' : 'bg-secondary'}`}>{u.role}</span></td>
                <td>{new Date(u.createdAt).toLocaleString()}</td>
              </tr>
            ))}
            {users.length === 0 && (
              <tr><td colSpan="4" className="text-muted text-center">No users found</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
